import React from "react";
import SourceOneAssistant from "./Apps/SourceOneAssistant";
export const builtInApps = [
   {
      id: "srcOneAssistant",
      name: "SourceOne Assistant",
      icon: "",
      component: <SourceOneAssistant />,
      description: "SourceOne Assistant",
      isBuiltIn: true,
   },
];
